import { default as ExpenseCompleted } from "./ExpenseCompleted";
import { default as ExpenseIncompleted } from "./ExpenseIncompleted";
import { default as Invoiced } from "./Invoiced";
import { default as OurWorkCompleted } from "./OurWorkCompleted";
import { default as OurWorkIncompleted } from "./OurWorkIncompleted";
import { default as Uninvoiced } from "./Uninvoiced";

export const Banner = {
  OurWorkCompleted,
  OurWorkIncompleted,
  ExpenseCompleted,
  ExpenseIncompleted,
  Invoiced,
  Uninvoiced,
};
